import { BarTone } from '../benchmark/kpiCardLogic'
import { ScoreBand } from '../profileLogic'

// TODO: the design's visualization/positive/700 (#4F8D73) has no palette token; emerald is the closest
export const POSITIVE_COLOR = 'brandDecorative.emerald'

export const SCORE_BAR_COLOR: Record<ScoreBand, string> = {
  [ScoreBand.VeryLow]: 'semantic.error',
  [ScoreBand.Low]: 'error.dark',
  [ScoreBand.Medium]: 'warning.dark',
  [ScoreBand.High]: 'success.main',
  [ScoreBand.VeryHigh]: POSITIVE_COLOR,
}

// The design's legend uses the lighter shade of the low and medium bands.
export const SCORE_LEGEND_COLOR: Record<ScoreBand, string> = {
  ...SCORE_BAR_COLOR,
  [ScoreBand.Low]: 'error.main',
  [ScoreBand.Medium]: 'warning.main',
}

export const TONE_COLOR: Record<BarTone, string> = {
  [BarTone.Positive]: POSITIVE_COLOR,
  [BarTone.Negative]: 'error.dark',
  [BarTone.Warning]: 'warning.dark',
}

export const LEVEL_TONE_COLOR: Record<BarTone, string> = {
  ...TONE_COLOR,
  [BarTone.Positive]: 'success.dark',
}
